module.exports = "<div class=\"root_wrapper\">\n    <title-bar item=\"$ctrl.ccaSession.activeSection\" ng-show=\"$ctrl.ccaSession.activeSection.showTitleBar\"></title-bar>\n    <div class=\"root_view\" ng-view autoscroll></div>\n    <menu-bar item=\"$ctrl.ccaSession.activeSection\" ng-show=\"$ctrl.ccaSession.activeSection.showMenu\"></menu-bar>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/frontend/modules/root/components/root/root.html
// module id = 358
// module chunks = 0